import { render, staticRenderFns } from "./CreatePaymentWidget.vue?vue&type=template&id=1135507d&"
import script from "./CreatePaymentWidget.vue?vue&type=script&lang=js&"
export * from "./CreatePaymentWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports